import React, { useState, useEffect } from "react";
import { withStyles, Drawer } from "@material-ui/core";
import Menu from "@jll/menu";
import { NavLink } from "react-router-dom";
import { NoAccessScreen } from "../../../../Component";
import { recordTypes } from "../../../../API/config";

import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const AdminSideMenu = (props) => {
  const { classes, hasPermission, hasAnyRecordPermission } = props;
  const { t } = useTranslation();

  const [hasAuditPermission, setHasAuditPermission] = useState();
  const [hasCountryPermission, setHasCountryPermission] = useState();
  const [hasSystemPermission, setHasSystemPermission] = useState();
  const [
    hasAccessControlPermission,
    setHasAccessControlPermission,
  ] = useState();

  const [hasDashboardPermission, setHasDashboardPermission] = useState();

  useEffect(() => {
    const evalPermissions = async () => {
      const hasAuditPermission = await hasPermission(
        recordTypes.auditRecord,
        recordTypes.auditRecord.actions.view.name
      );

      setHasAuditPermission(hasAuditPermission);
      const hasCountryPermission = await hasAnyRecordPermission([
        recordTypes.country.name,
        recordTypes.countryRegulator.name,
        recordTypes.countryExchange.name,
        recordTypes.countryRiskData.name,
      ]);
      setHasCountryPermission(hasCountryPermission);

      const hasAccessControlPermission = await hasPermission(
        recordTypes.accessRule.name,
        recordTypes.accessRule.actions.view.name
      );
      setHasAccessControlPermission(hasAccessControlPermission);

      const hasSystemPermission = await hasPermission(
        recordTypes.system.name,
        recordTypes.system.actions.clearCache.name
      );
      setHasSystemPermission(hasSystemPermission);

      const hasDashboardPermission = await hasPermission(
        recordTypes.adminDashboard.name,
        recordTypes.adminDashboard.actions.view.name
      );
      setHasDashboardPermission(hasDashboardPermission);
    };
    evalPermissions();
  }, []);

  if (!hasAuditPermission &&
    !hasCountryPermission &&
    !hasSystemPermission &&
    !hasDashboardPermission) {
    return <NoAccessScreen />;
  }

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="left"
    >
      <Menu>
        {hasAuditPermission && (
          <NavLink
            to={"/auditInfo"}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.auditRecords")}
          </NavLink>
        )}
        {hasCountryPermission && (
          <NavLink
            to={"/countryData"}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.countryData")}
          </NavLink>
        )}
        {hasAccessControlPermission && (
          <NavLink
            to={"/accessControl"}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.manageAccessControl")}
          </NavLink>
        )}
        {hasSystemPermission && (
          <NavLink
            to={"/system"}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.system")}
          </NavLink>
        )}
        {hasDashboardPermission && (
          <NavLink
            to={"/dashboard"}
            className={classes.menuItem}
            activeClassName={classes.menuItemActive}
          >
            {t("labels.admin.dashboard")}
          </NavLink>
        )}
      </Menu>
    </Drawer>
  );
};

export default withStyles(styles, { withTheme: true })(AdminSideMenu);
